import React, { useEffect, useState } from "react";

function Admin() {

  const [visits, setVisits] = useState([]);
  const [form, setForm] = useState({
      name: "",
      phone: ""
      
    });
     
    const handleChange = (e) => {
      
      setForm({ ...form, [e.target.name]: e.target.value });
    };
  
    const handleSubmit = (e) => {
      e.preventDefault();
      alert("Message Sent Successfully ✅");
      
      setForm({ name: "", phone: ""});
      
    };
  

  useEffect(() => {
    const storedData =
      JSON.parse(localStorage.getItem("siteVisits")) || [];
      
    setVisits(storedData);
    
  }, []);
  

  return (
    <div className="container mt-5">

      <h2 className="text-center mb-4">Site Visit Bookings</h2>

      {visits.length === 0 ? (
        <p className="text-center">No bookings yet.</p>
      ) : (
        <table className="table table-bordered">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Phone</th>
            </tr>
          </thead>

          <tbody>
            {visits.map((visit, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{visit.name}</td>
                <td>{visit.phone}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

    </div>
  );
}

export default Admin;
